/* Packs de empresa · Imprimirlo
 * Sustituye a Upload-Lift y a Live Product Options en las fichas de packs.
 * El cliente reparte las prendas por color y talla, sube el logo del pecho
 * (y opcionalmente el de la espalda) y lo añade al carrito con la subida
 * nativa de Shopify (multipart).
 */
(function () {
  'use strict';

  function $(r, s) { return r.querySelector(s); }
  function $$(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function money(c) { return (c / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' }); }
  function fmt(n, d) { return Number(n).toLocaleString('es-ES', { minimumFractionDigits: d || 0, maximumFractionDigits: d == null ? 1 : d }); }
  function numero(t) { var m = String(t).match(/(\d+)/); return m ? parseInt(m[1], 10) : 0; }

  /* «Editar diseño» desde el carrito: el diseño del editor se guarda en este navegador (la misma base que usan las demás fichas con editor)
     y la línea del carrito lleva su identificador en _diseno. La ficha lo recupera con ?editar=<id>. */
  function conLimite(promesa, ms) {
    return new Promise(function (ok, ko) {
      var t = setTimeout(function () { ko(new Error('tiempo')); }, ms);
      promesa.then(function (v) { clearTimeout(t); ok(v); }, function (e) { clearTimeout(t); ko(e); });
    });
  }
  var Diseños = {
    abrir: function () {
      return new Promise(function (ok, ko) {
        if (!window.indexedDB) return ko(new Error('sin indexedDB'));
        var r = indexedDB.open('imprimirlo-disenos', 1);
        r.onupgradeneeded = function () { r.result.createObjectStore('disenos'); };
        r.onsuccess = function () { ok(r.result); };
        r.onerror = function () { ko(r.error); };
      });
    },
    guardar: function (id, valor) {
      return Diseños.abrir().then(function (db) {
        return new Promise(function (ok, ko) {
          var t = db.transaction('disenos', 'readwrite');
          t.objectStore('disenos').put({ v: valor, t: Date.now() }, id);
          t.oncomplete = function () { db.close(); ok(); };
          t.onerror = function () { db.close(); ko(t.error); };
        });
      });
    },
    leer: function (id) {
      return Diseños.abrir().then(function (db) {
        return new Promise(function (ok, ko) {
          var r = db.transaction('disenos').objectStore('disenos').get(id);
          r.onsuccess = function () { db.close(); ok(r.result ? r.result.v : null); };
          r.onerror = function () { db.close(); ko(r.error); };
        });
      });
    }
  };

  function Pack(root) {
    this.root = root;
    this.cfg = JSON.parse($(root, '[data-pke-config]').textContent);
    this.colores = this.cfg.colores && this.cfg.colores.length ? this.cfg.colores : ['Negro'];
    // un grupo normal, o varios en los packs mixtos (5 camisetas + 5 polos)
    this.grupos = (this.cfg.grupos && this.cfg.grupos.length) ? this.cfg.grupos : [{ nombre: '', uds: null }];
    var self = this;
    this.filas = this.grupos.map(function () { return [{ color: self.colores[0], tallas: {} }]; });
    this.archivos = {};
    this.busy = false;
    this.pintarReparto();
    this.pintarTablas();
    this.bind();
    if (this.cfg.vista) this.montarEditor();
    this.actualizar();
  }

  /* Tabla de tallas y ficha técnica: se pintan solas si el producto tiene los datos.
     medidas: [{"talla":"S","pecho":49,"largo":71}, ...] · ficha: [{"nombre":"Composición","valor":"..."}] */
  Pack.prototype.pintarTablas = function () {
    var med = this.cfg.medidas || [], caja = $(this.root, '[data-medidas]');
    if (caja && med.length) {
      var cols = [];
      med.forEach(function (f) {
        Object.keys(f).forEach(function (k) { if (cols.indexOf(k) === -1) cols.push(k); });
      });
      var html = '<table><thead><tr>' + cols.map(function (c) {
        return '<th>' + c.charAt(0).toUpperCase() + c.slice(1) + '</th>';
      }).join('') + '</tr></thead><tbody>';
      med.forEach(function (f) {
        html += '<tr>' + cols.map(function (c) { return '<td>' + (f[c] == null ? '—' : f[c]) + '</td>'; }).join('') + '</tr>';
      });
      $(this.root, '[data-tabla]').innerHTML = html + '</tbody></table>';
      caja.hidden = false;
    }
    var ficha = this.cfg.ficha || [], cajaF = $(this.root, '[data-ficha]');
    if (cajaF && ficha.length) {
      $(this.root, '[data-ficha-tabla]').innerHTML = '<table><tbody>' + ficha.map(function (f) {
        return '<tr><th>' + f.nombre + '</th><td>' + f.valor + '</td></tr>';
      }).join('') + '</tbody></table>';
      cajaF.hidden = false;
    }
  };

  /* ---------- variante y tamaño del pack ---------- */
  Pack.prototype.variante = function () {
    var v = this.cfg.variantes;
    var campo = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (campo && campo.value) {
      var enc = v.filter(function (x) { return String(x.id) === String(campo.value); })[0];
      if (enc) return enc;
    }
    var elegidas = [];
    document.querySelectorAll('variant-selects select, variant-radios input:checked, .product-form__input select, .product-form__input input:checked')
      .forEach(function (el) { if (el.value) elegidas.push(el.value.trim()); });
    if (elegidas.length) {
      var m = v.filter(function (x) {
        return x.opts.every(function (o, i) { return elegidas[i] == null || o === elegidas[i]; });
      })[0];
      if (m) return m;
    }
    return v[0] || null;
  };

  // "Pack 10 unidades" -> 10
  Pack.prototype.unidades = function () {
    var v = this.variante();
    if (!v) return this.cfg.unidadesPorDefecto;
    var n = 0;
    v.opts.forEach(function (o) { var x = numero(o); if (x > n) n = x; });
    return n || this.cfg.unidadesPorDefecto;
  };

  Pack.prototype.objetivo = function (i) {
    var g = this.grupos[i];
    if (g.uds) return g.uds;
    if (this.grupos.length === 1) return this.unidades();
    return Math.round(this.unidades() / this.grupos.length);
  };

  Pack.prototype.repartidas = function (i) {
    var self = this, t = 0;
    this.filas[i].forEach(function (f) {
      self.cfg.tallas.forEach(function (s) { t += f.tallas[s] || 0; });
    });
    return t;
  };

  Pack.prototype.hex = function (color) { return this.cfg.hex[color] || '#cccccc'; };

  /* Packs disponibles de este producto, ordenados por unidades: sirve para
     sugerir el que le cuadra a quien se pasa o se queda corto. */
  Pack.prototype.packs = function () {
    var vistos = {}, lista = [];
    this.cfg.variantes.forEach(function (v) {
      var n = 0;
      v.opts.forEach(function (o) { var x = numero(o); if (x > n) n = x; });
      if (!n || vistos[n]) return;
      vistos[n] = 1;
      lista.push({ uds: n, precio: v.precio, variante: v });
    });
    return lista.sort(function (a, b) { return a.uds - b.uds; });
  };

  // cambia la variante moviendo el selector del tema, para que precio y carrito cuadren
  Pack.prototype.cambiarPack = function (v) {
    var cambiado = false;
    document.querySelectorAll('variant-selects select, .product-form__input select').forEach(function (sel) {
      v.opts.forEach(function (valor) {
        var tiene = Array.prototype.some.call(sel.options, function (o) { return o.value === valor; });
        if (tiene && sel.value !== valor) {
          sel.value = valor;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          cambiado = true;
        }
      });
    });
    if (!cambiado) {
      var campo = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (campo) { campo.value = v.id; campo.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    var self = this;
    setTimeout(function () { self.actualizar(); }, 60);
  };

  // suplemento por talla grande: cubre la diferencia de coste de la prenda
  Pack.prototype.suplemento = function (talla) {
    var l = this.cfg.suplementos || [];
    return l.filter(function (s) { return s.talla === talla; })[0] || null;
  };

  // [{talla, id, precio, uds}] con las tallas grandes que lleva el pedido
  Pack.prototype.extras = function () {
    var self = this, mapa = {};
    this.filas.forEach(function (grupo) {
      grupo.forEach(function (fila) {
        Object.keys(fila.tallas).forEach(function (s) {
          var n = fila.tallas[s] || 0, sup = self.suplemento(s);
          if (n > 0 && sup) {
            if (!mapa[s]) mapa[s] = { talla: s, id: sup.id, precio: sup.precio, uds: 0 };
            mapa[s].uds += n;
          }
        });
      });
    });
    return Object.keys(mapa).map(function (k) { return mapa[k]; });
  };

  Pack.prototype.extraTotal = function () {
    return this.extras().reduce(function (t, e) { return t + e.precio * e.uds; }, 0);
  };

  Pack.prototype.libres = function (i, propio) {
    var usados = this.filas[i].map(function (f) { return f.color; });
    return this.colores.filter(function (c) { return c === propio || usados.indexOf(c) === -1; });
  };

  /* ---------- pintado ---------- */
  Pack.prototype.pintarReparto = function () {
    var self = this, cont = $(this.root, '[data-reparto]');
    cont.innerHTML = '';
    this.grupos.forEach(function (g, i) {
      var bloque = document.createElement('div');
      bloque.className = 'pke-grupo'; bloque.dataset.grupo = i;
      if (g.nombre) bloque.innerHTML = '<p class="pke-grupo__t">' + g.nombre + '</p>';

      var filas = document.createElement('div');
      filas.className = 'pke-filas'; filas.dataset.filas = i;
      bloque.appendChild(filas);

      var mas = document.createElement('button');
      mas.type = 'button'; mas.className = 'pke-mas'; mas.dataset.mas = i;
      mas.textContent = '+ Añadir otro color';
      mas.hidden = true;   // un solo color por pack (Xavi, 24/10: «no quiero que me pidan 2 verdes, 2 rojas, 2 azules»)
      mas.addEventListener('click', function () {
        var libres = self.libres(i);
        if (!libres.length) return;
        self.filas[i].push({ color: libres[0], tallas: {} });
        self.pintarFilas(i);
        self.actualizar();
      });
      bloque.appendChild(mas);

      var cuenta = document.createElement('p');
      cuenta.className = 'pke-cuenta'; cuenta.dataset.cuenta = i;
      bloque.appendChild(cuenta);
      cont.appendChild(bloque);
      self.pintarFilas(i);
    });
  };

  Pack.prototype.pintarFilas = function (i) {
    var self = this, cont = $(this.root, '[data-filas="' + i + '"]');
    cont.innerHTML = '';
    this.filas[i].forEach(function (fila, j) {
      var caja = document.createElement('div');
      caja.className = 'pke-fila';

      var cab = document.createElement('div');
      cab.className = 'pke-fila__cab';
      var punto = document.createElement('i');
      punto.className = 'pke-punto'; punto.style.background = self.hex(fila.color);
      cab.appendChild(punto);

      var sel = document.createElement('select');
      sel.className = 'pke-color'; sel.setAttribute('aria-label', 'Color');
      self.libres(i, fila.color).forEach(function (c) {
        var o = document.createElement('option');
        o.value = c; o.textContent = c; o.selected = c === fila.color;
        sel.appendChild(o);
      });
      sel.addEventListener('change', function () {
        fila.color = sel.value; punto.style.background = self.hex(fila.color);
        self.pintarFilas(i); self.actualizar();
      });
      if (self.cfg.vista) {
        // con editor el color se elige en las bolitas de arriba: aquí solo se nombra
        var nom = document.createElement('span'); nom.className = 'pke-color-nombre'; nom.textContent = fila.color;
        cab.appendChild(nom);
      } else cab.appendChild(sel);

      if (self.filas[i].length > 1) {
        var quitar = document.createElement('button');
        quitar.type = 'button'; quitar.className = 'pke-quitar'; quitar.textContent = '×';
        quitar.setAttribute('aria-label', 'Quitar ' + fila.color);
        quitar.addEventListener('click', function () {
          self.filas[i].splice(j, 1); self.pintarFilas(i); self.actualizar();
        });
        cab.appendChild(quitar);
      }
      caja.appendChild(cab);

      var rejilla = document.createElement('div');
      rejilla.className = 'pke-tallas';
      self.cfg.tallas.forEach(function (s) {
        var l = document.createElement('label');
        l.className = 'pke-talla'; l.dataset.talla = s;
        l.innerHTML = '<span>' + s + '</span><input type="number" min="0" max="999" inputmode="numeric" ' +
          'value="' + (fila.tallas[s] || 0) + '" aria-label="' + fila.color + ' talla ' + s + '">';
        var input = l.querySelector('input');
        input.addEventListener('input', function () {
          var n = parseInt(input.value, 10);
          fila.tallas[s] = isNaN(n) || n < 0 ? 0 : n;
          l.classList.toggle('is-usada', fila.tallas[s] > 0);
          self.actualizar();
        });
        input.addEventListener('focus', function () { if (input.value === '0') input.select(); });
        l.classList.toggle('is-usada', (fila.tallas[s] || 0) > 0);
        rejilla.appendChild(l);
      });
      caja.appendChild(rejilla);
      cont.appendChild(caja);
    });
  };

  Pack.prototype.bind = function () {
    var self = this, r = this.root;
    $$(r, '[data-logo]').forEach(function (caja) {
      var clave = caja.dataset.logo;
      var input = $(caja, 'input[type="file"]'), drop = $(caja, '[data-drop]');
      drop.addEventListener('click', function (e) { e.preventDefault(); input.click(); });
      input.addEventListener('change', function () { self.cargar(clave, input.files[0]); input.value = ''; });
      ['dragenter', 'dragover'].forEach(function (ev) {
        drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); });
      });
      drop.addEventListener('drop', function (e) { self.cargar(clave, e.dataTransfer.files[0]); });
      $(caja, '[data-quitar-logo]').addEventListener('click', function () {
        delete self.archivos[clave]; self.pintarLogo(clave); self.actualizar();
      });
      caja.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-fix]');
        if (!b) return;
        if (b.dataset.fix === 'deshacer') self.deshacer(clave);
        else self.arreglar(clave, b.dataset.fix);
      });
    });
    // tabla de tallas: se abre en una ventana encima, sin salir de la ficha
    var abrir = $(r, '[data-abrir-medidas]'), modal = $(r, '[data-modal-medidas]');
    if (abrir && modal) {
      abrir.addEventListener('click', function () {
        if (modal.showModal) modal.showModal();
        else modal.classList.add('is-abierto');
      });
      $$(r, '[data-cerrar-medidas]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (modal.close) modal.close();
          modal.classList.remove('is-abierto');
        });
      });
      // clic fuera de la tabla también cierra
      modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
    }
    $(r, '[data-add]').addEventListener('click', function () { self.alCarrito(); });
    var bPres = $(r, '[data-presupuesto]');
    if (bPres) bPres.addEventListener('click', function () { self.alCarrito(true); });
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects, variant-radios, .product-form__input, [name="id"]')) {
        setTimeout(function () { self.actualizar(); }, 30);
      }
    });
    window.addEventListener('popstate', function () { self.actualizar(); });
  };

  Pack.prototype.flash = function (msg) {
    if (window.Cargando) Cargando.aviso(msg, 9000);
  };

  /* ---------- logos ---------- */
  Pack.prototype.cargar = async function (clave, file) {
    if (!file) return;
    if (file.size > this.cfg.maxFileMb * 1048576) {
      return this.flash(file.name + ': pesa más de ' + this.cfg.maxFileMb + ' MB. Mándanoslo por WhatsApp.');
    }
    var dato = { file: file, name: file.name, px: null, transparente: null, thumb: null };
    // se tapa la caja y se deja pintar: el análisis de píxeles bloquea el hilo
    var destapar = function () {};
    if (window.Cargando && /png|jpe?g|webp/i.test(file.type)) {
      destapar = Cargando.velo($(this.root, '[data-logo="' + clave + '"]'),
        'Leyendo el logo…', 'Comprobamos resolución y fondo');
      await Cargando.pinta();
    }
    if (/png|jpe?g|webp/i.test(file.type)) {
      try {
        var bmp = await createImageBitmap(file);
        var W = bmp.width, H = bmp.height;
        var e = Math.min(1, Math.sqrt(4e6 / (W * H)));
        var cw = Math.max(1, Math.round(W * e)), ch = Math.max(1, Math.round(H * e));
        var c = document.createElement('canvas'); c.width = cw; c.height = ch;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(bmp, 0, 0, cw, ch);
        var d = ctx.getImageData(0, 0, cw, ch).data;
        var minX = cw, minY = ch, maxX = -1, maxY = -1, transp = false;
        for (var y = 0; y < ch; y++) for (var x = 0; x < cw; x++) {
          var a = d[(y * cw + x) * 4 + 3];
          if (a < 250) transp = true;
          if (a >= 8) { if (x < minX) minX = x; if (x > maxX) maxX = x; if (y < minY) minY = y; if (y > maxY) maxY = y; }
        }
        if (maxX < 0) { if (bmp.close) bmp.close(); destapar(); return this.flash(file.name + ': la imagen está vacía.'); }
        var caja = {
          x: Math.floor(minX / e), y: Math.floor(minY / e),
          w: Math.ceil((maxX + 1 - minX) / e), h: Math.ceil((maxY + 1 - minY) / e)
        };
        var t = Math.min(1, 260 / Math.max(caja.w, caja.h));
        var th = document.createElement('canvas');
        th.width = Math.max(1, Math.round(caja.w * t)); th.height = Math.max(1, Math.round(caja.h * t));
        th.getContext('2d').drawImage(bmp, caja.x, caja.y, caja.w, caja.h, 0, 0, th.width, th.height);
        if (bmp.close) bmp.close();
        dato.px = [caja.w, caja.h]; dato.transparente = transp; dato.thumb = th;
      } catch (err) { /* si no se puede leer, se sube igual */ }
    }
    destapar();
    this.archivos[clave] = dato;
    this.pintarLogo(clave);
    this.actualizar();
  };

  Pack.prototype.anchoNitido = function (px) { return px / (this.cfg.dpiGood / 2.54); };

  Pack.prototype.pintarLogo = function (clave) {
    var caja = $(this.root, '[data-logo="' + clave + '"]'), a = this.archivos[clave];
    $(caja, '[data-archivo]').hidden = !a;
    $(caja, '[data-drop]').hidden = !!a;
    if (!a) return;
    $(caja, '[data-nombre]').textContent = a.name;
    var thumb = $(caja, '[data-thumb]');
    thumb.innerHTML = '';
    if (a.thumb) thumb.appendChild(a.thumb);
    else thumb.textContent = (a.name.split('.').pop() || '?').toUpperCase();

    var partes = [];
    if (a.px) {
      var cm = this.anchoNitido(a.px[0]);
      var k = cm >= 20 ? 'ok' : (cm >= 8 ? 'mid' : 'low');
      partes.push('<span class="pke-badge pke-badge--' + k + '">' +
        (k === 'ok' ? 'Resolución de sobra' : k === 'mid' ? 'Resolución correcta' : 'Resolución justa') + '</span>');
      partes.push('Nítido hasta ' + fmt(cm, 1) + ' cm de ancho' +
        (k === 'low' ? '. Si lo tienes en vectorial (AI, EPS o PDF), mándanoslo mejor.' : '.'));
      /* Al quitar el fondo, el número baja: antes se medía el rectángulo entero
         y ahora solo el logo. Es más exacto, pero si no se explica parece que
         el arreglo haya empeorado el archivo. */
      if (a.anterior && a.anterior.px && a.px[0] < a.anterior.px[0] &&
          (a.arreglos || []).indexOf('fondo') !== -1) {
        partes.push('<span class="pke-muted">Ese número ha bajado porque ahora medimos solo el logo, ' +
          'sin el fondo que acabamos de quitar. El archivo no ha perdido nada.</span>');
      }
      a.nota = a.px[0] + '×' + a.px[1] + ' px · nítido hasta ' + fmt(cm, 1) + ' cm';
      if (a.transparente === false) {
        partes.push('<span class="pke-badge pke-badge--mid">Fondo no transparente</span> Lo recortamos nosotros, ' +
          'pero si lo quitas aquí lo ves antes de comprar.');
      }
    } else {
      partes.push('Archivo vectorial: lo revisamos nosotros.');
      a.nota = 'archivo vectorial';
    }
    $(caja, '[data-info]').innerHTML = partes.join(' ');
    this.pintarArreglos(clave);
  };

  /* ---------- arreglos del logo ----------
     Los mismos que en las fichas de transfers: se hace aquí, en el navegador,
     y el archivo que llega al taller ya es el bueno. Siempre se puede deshacer. */
  Pack.prototype.pintarArreglos = function (clave) {
    var caja = $(this.root, '[data-logo="' + clave + '"]');
    var zona = $(caja, '[data-arreglos]');
    if (!zona) return;
    var a = this.archivos[clave];
    if (!a || !a.px || !window.ImgArreglo) { zona.hidden = true; return; }
    var hechos = a.arreglos || [], btns = [];
    if (a.transparente === false && hechos.indexOf('fondo') === -1) {
      btns.push('<button type="button" class="pke-fix" data-fix="fondo">Quitar el fondo</button>');
    }
    if (hechos.indexOf('bordes') === -1 && a.px[0] <= 1500 && this.anchoNitido(a.px[0]) < 20) {
      btns.push('<button type="button" class="pke-fix" data-fix="bordes">Afinar los bordes</button>');
    }
    if (a.anterior) btns.push('<button type="button" class="pke-fix pke-fix--gris" data-fix="deshacer">Deshacer</button>');
    zona.innerHTML = btns.join('');
    zona.hidden = !btns.length;
  };

  Pack.prototype.arreglar = async function (clave, tipo) {
    var a = this.archivos[clave];
    if (!a || !a.px || !window.ImgArreglo || this.ocupado) return;
    var caja = $(this.root, '[data-logo="' + clave + '"]');
    var btn = $(caja, '[data-fix="' + tipo + '"]'), texto = btn ? btn.textContent : '';
    this.ocupado = true;
    var soltar = function () { if (btn) { btn.disabled = false; btn.textContent = texto; } };
    if (window.Cargando) {
      Cargando.ocupar(btn, tipo === 'fondo' ? 'Quitando el fondo…' : 'Afinando…');
      soltar = function () { Cargando.libre(btn, texto); };
      await Cargando.pinta();
    } else if (btn) { btn.disabled = true; btn.textContent = 'Un momento…'; }
    try {
      var bmp = await createImageBitmap(a.file);
      var lienzo = document.createElement('canvas');
      lienzo.width = bmp.width; lienzo.height = bmp.height;
      lienzo.getContext('2d', { willReadFrequently: true }).drawImage(bmp, 0, 0);
      if (bmp.close) bmp.close();
      var res = tipo === 'fondo' ? ImgArreglo.quitarFondo(lienzo) : ImgArreglo.afinarBordes(lienzo, 3);
      if (!res.ok) {
        this.ocupado = false; soltar();
        return this.flash(tipo === 'fondo'
          ? 'No hemos encontrado un fondo liso que quitar. Súbelo tal cual y lo recortamos nosotros.'
          : 'Ese archivo ya tiene tamaño de sobra, no hace falta afinarlo.');
      }
      var base = a.name.replace(/\.[^.]+$/, '');
      var nuevo = await ImgArreglo.aFichero(res.lienzo, base + (tipo === 'fondo' ? '-sin-fondo' : '-afinado') + '.png');
      var anterior = {
        file: a.file, name: a.name, px: a.px, transparente: a.transparente,
        thumb: a.thumb, arreglos: (a.arreglos || []).slice(), anterior: a.anterior
      };
      await this.cargar(clave, nuevo);
      var b = this.archivos[clave];
      if (b) { b.anterior = anterior; b.arreglos = anterior.arreglos.concat([tipo]); }
      this.pintarLogo(clave);
    } catch (e) {
      this.flash('No hemos podido arreglar esa imagen. Súbela tal cual y ya la miramos nosotros.');
    }
    this.ocupado = false; soltar();
    this.actualizar();
  };

  Pack.prototype.deshacer = function (clave) {
    var a = this.archivos[clave];
    if (!a || !a.anterior) return;
    this.archivos[clave] = a.anterior;
    this.pintarLogo(clave);
    this.actualizar();
  };

  /* ---------- estado ---------- */
  /* Escalado de packs con su precio (en vez del desplegable del tema): se ve cuánto baja el precio por unidad. */
  Pack.prototype.pintarEscala = function () {
    var self = this, packs = this.packs();
    if (packs.length < 2) return;
    if (!this.escala) {
      this.escala = document.createElement('div');
      this.escala.className = 'pke-escala';
      this.root.parentNode.insertBefore(this.escala, this.root);
      document.body.classList.add('pke-con-escala');   // el CSS esconde el desplegable también cuando Dawn lo vuelve a pintar al cambiar de pack
      document.querySelectorAll('variant-selects').forEach(function (e) { e.style.display = 'none'; });   // el selector sigue ahí (lo mueve cambiarPack)
      this.escala.addEventListener('click', function (e) {
        var b = e.target.closest('[data-pack-uds]');
        if (!b) return;
        var p = self.packs().filter(function (x) { return String(x.uds) === b.getAttribute('data-pack-uds'); })[0];
        if (p) self.cambiarPack(p.variante);
      });
    }
    var actual = this.variante(), u0 = packs[0].precio / packs[0].uds;
    this.escala.innerHTML = '<p class="pke-escala__t">Elige el pack <small>· precio total, IVA incluido</small></p>' + packs.map(function (p) {
      var u = p.precio / p.uds, ahorro = Math.round((1 - u / u0) * 100);
      return '<button type="button" class="pke-escala__fila' + (actual && actual.id === p.variante.id ? ' on' : '') + '" data-pack-uds="' + p.uds + '">' +
        '<span class="n">Pack ' + p.uds + '</span><span class="u">' + money(u) + '/ud' + (ahorro >= 3 ? ' <em>−' + ahorro + ' %</em>' : '') + '</span><span class="p">' + money(p.precio) + '</span></button>';
    }).join('');
  };

  Pack.prototype.actualizar = function () {
    if (this.ed) this.sincronizarColor();
    var r = this.root, self = this;
    this.pintarEscala();
    if (this.vista) this.vista.pintar();
    var v = this.variante(), todoOk = true;

    this.grupos.forEach(function (g, i) {
      var uds = self.objetivo(i), rep = self.repartidas(i);
      var bloque = $(r, '.pke-grupo[data-grupo="' + i + '"]');
      var cuenta = $(bloque, '[data-cuenta]');
      var ok = rep === uds;
      if (!ok) todoOk = false;
      cuenta.classList.toggle('is-ok', ok);
      var dif = Math.abs(uds - rep);
      if (rep === 0) cuenta.innerHTML = 'Reparte las <b>' + uds + '</b> unidades entre colores y tallas.';
      else if (rep < uds) cuenta.innerHTML = '<b>' + rep + ' de ' + uds + '</b> repartidas · te ' + (dif === 1 ? 'falta 1' : 'faltan ' + dif) + '.';
      else if (rep > uds) cuenta.innerHTML = '<b>' + rep + ' de ' + uds + '</b> repartidas · te ' + (dif === 1 ? 'sobra 1' : 'sobran ' + dif) + '.';
      else cuenta.innerHTML = '<b>' + uds + ' de ' + uds + '</b> repartidas. Todo cuadra.';

      // si hay un pack que le cuadra mejor, se le ofrece cambiar
      if (!ok && self.grupos.length === 1 && rep > 0) {
        var packs = self.packs(), sug = null;
        if (rep > uds) sug = packs.filter(function (p) { return p.uds >= rep; })[0];
        else sug = packs.filter(function (p) { return p.uds === rep; })[0];
        if (sug && sug.uds !== uds) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'pke-sugerencia';
          b.innerHTML = 'Cambiar al pack de ' + sug.uds + ' · ' + money(sug.precio);
          b.addEventListener('click', function () { self.cambiarPack(sug.variante); });
          cuenta.appendChild(document.createElement('br'));
          cuenta.appendChild(b);
        }
      }
      var mas = $(bloque, '[data-mas]');
      mas.hidden = true;   // un solo color por pack
    });

    var falta = [];
    if (!todoOk) falta.push('el reparto de tallas');
    if (this.cfg.pechoObligatorio && !this.archivos.pecho) falta.push('el logo del pecho');

    // aviso de suplementos por talla grande
    var avisoSup = $(r, '[data-suplementos]');
    if (avisoSup) {
      var lista = (this.cfg.suplementos || []).map(function (s) { return s.talla + ' +' + money(s.precio); });
      var extras = this.extras();
      if (extras.length) {
        avisoSup.innerHTML = 'Llevas ' + extras.map(function (e) { return e.uds + ' × ' + e.talla; }).join(' y ') +
          ': se añade un suplemento de <strong>' + money(this.extraTotal()) + '</strong> por la diferencia de coste de la prenda.';
        avisoSup.hidden = false;
      } else if (lista.length) {
        avisoSup.innerHTML = 'Tallas grandes con suplemento por prenda: ' + lista.join(' · ') + '.';
        avisoSup.hidden = false;
      } else {
        avisoSup.hidden = true;
      }
    }

    var extra = this.extraTotal();
    var btn = $(r, '[data-add]');
    if (!this.busy && window.Cargando) Cargando.libre(btn);
    btn.disabled = falta.length > 0 || !v || this.busy;
    if (!this.busy) btn.textContent = v ? 'Añadir al carrito · ' + money(v.precio + extra) : 'Añadir al carrito';
    // «Enviar presupuesto»: mismas condiciones que el carrito; mientras se prepara queda desactivado con su texto
    var bPres = $(r, '[data-presupuesto]');
    if (bPres && !this.busy) {
      bPres.disabled = falta.length > 0 || !v;
      bPres.textContent = 'Crear presupuesto';
    }
    /* el mismo aviso, arriba, para la ventana de tallas del móvil (allí el pie va escondido y no se sabía por qué no dejaba continuar) */
    if (!this.avisoFalta) { this.avisoFalta = document.createElement('p'); this.avisoFalta.className = 'pke__falta'; r.insertBefore(this.avisoFalta, r.firstChild); }
    this.avisoFalta.textContent = falta.length ? 'Para continuar falta ' + falta.join(' y ') + '.' : '';
    var pie = $(r, '[data-pie]');
    if (pie) {
      if (falta.length) {
        pie.textContent = 'Para continuar falta ' + falta.join(' y ') + '.';
      } else {
        var total = 0;
        this.grupos.forEach(function (g, i) { total += self.objetivo(i); });
        var unidad = v && total ? money(Math.round((v.precio + extra) / total)) : null;
        pie.textContent = (unidad ? 'Salen a ' + unidad + ' por prenda, IVA y personalización incluidos. ' : '') +
          'Antes de producir te mandamos una prueba para que la apruebes.';
      }
    }
  };

  /* ---------- carrito ---------- */

  /* ---------- editor libre en el pack ----------
     Mismo editor que las camisetas, pero con las zonas FIJAS del pack: pecho izquierdo 8×8 cm y espalda 28×15 cm
     (los packs son de tamaño limitado). Lo que se compone en cada zona viaja como el «logo» de esa cara. */
  Pack.prototype.montarEditor = function () {
    var self = this, cfg = this.cfg.vista;
    var host = document.querySelector('[data-libre-editor-host]');
    if (!host) return;
    var intentos = 0;
    var espera = setInterval(function () {
      if (window.EditorLibre && window.Colocacion) { clearInterval(espera); self.iniciarEditor(host, cfg); }
      else if (++intentos > 100) clearInterval(espera);
    }, 100);
  };

  // una foto sin versión propia en ese color: la blanca teñida (multiplicar, sin tocar el fondo blanco)
  Pack.prototype.teñir = function (src, hex) {
    return new Promise(function (ok) {
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var cv = document.createElement('canvas'); cv.width = im.naturalWidth; cv.height = im.naturalHeight;
          var x = cv.getContext('2d'); x.drawImage(im, 0, 0);
          var d = x.getImageData(0, 0, cv.width, cv.height), p = d.data, h = String(hex || '#888888').replace('#', '');
          var R = parseInt(h.substr(0, 2), 16), G = parseInt(h.substr(2, 2), 16), B = parseInt(h.substr(4, 2), 16);
          for (var i = 0; i < p.length; i += 4) {
            if (p[i] > 250 && p[i + 1] > 250 && p[i + 2] > 250) continue;
            p[i] = p[i] * R / 255; p[i + 1] = p[i + 1] * G / 255; p[i + 2] = p[i + 2] * B / 255;
          }
          x.putImageData(d, 0, 0);
          ok(cv.toDataURL('image/jpeg', 0.85));
        } catch (e) { ok(src); }
      };
      im.onerror = function () { ok(src); };
      im.src = src;
    });
  };

  Pack.prototype.iniciarEditor = async function (host, cfg) {
    var self = this;
    var zp = { id: 'pack-pecho', nombre: 'Pecho izquierdo', cara: 'delante', libre: true, x: 100, y: 120, cajas: [cfg.cajas.pecho.cm], ventana: [0, 0] };
    var ze = { id: 'pack-espalda', nombre: 'Espalda', cara: 'espalda', libre: true, x: 100, y: 120, cajas: [cfg.cajas.espalda.cm], ventana: [cfg.cajas.pecho.cm[0], 0] };
    this.zonasEd = { pecho: zp, espalda: ze };
    var caras = ['pecho', 'espalda'], fotos = {}, base = cfg.fotos[cfg.base] || cfg.fotos.Blanco || cfg.fotos[Object.keys(cfg.fotos)[0]];
    var primero = this.colores[0];
    var porColor = { pecho: {}, espalda: {} };
    for (var i = 0; i < this.colores.length; i++) {
      var c = this.colores[i];
      for (var j = 0; j < caras.length; j++) {
        var k = caras[j];
        porColor[k][c] = cfg.fotos[c] ? cfg.fotos[c][k] : await this.teñir(base[k], this.hex(c));
      }
    }
    caras.forEach(function (k) {
      var b = cfg.cajas[k], m = cfg.pxCm;
      fotos['pack-' + k] = {
        fondo: porColor[k][primero], mascara: null, blanca: null, porColor: porColor[k],
        recuadro: { centro: b.cx / cfg.ancho, top: (b.cy - b.cm[1] * m / 2) / cfg.alto, height: b.cm[1] * m / cfg.alto }
      };
    });
    var fila0 = this.filas[0] && this.filas[0][0];
    var color = (fila0 && fila0.color) || primero;
    this._cEd = color;
    // en el móvil el hueco mide menos de lo que se supone al montar: se reajusta al ancho real una vez repartida la página
    var anchoHost = function () {
      var w = host.getBoundingClientRect().width || host.clientWidth || (window.innerWidth - 40);
      // en móvil se reserva la columna de las bolitas de color a la derecha
      if (window.innerWidth < 750 && self.colores.length > 1) w -= 36;
      /* en escritorio la camiseta no tan grande: que las vistas (Pecho izquierdo / Espalda) de debajo se vean sin bajar la página (Xavi, 24/10) */
      if (window.innerWidth >= 750 && cfg.ancho && cfg.alto) {
        var arriba = host.getBoundingClientRect().top + (window.pageYOffset || 0);
        var libre = window.innerHeight - arriba - 105;   // 81 px de las vistas + un respiro
        w = Math.min(w, Math.max(380, Math.floor(libre / (cfg.alto / cfg.ancho))));
      }
      return Math.max(240, Math.min(Math.floor(w), 620));
    };
    this.ed = EditorLibre.montar(host, {
      prenda: 'camiseta', zona: zp, vistas: [zp, ze], fotos: fotos,
      colorHex: this.hex(color), colorNombre: color, axilaCm: null,
      onCambio: function () { self.sincronizarEditor(); },
      ancho: anchoHost()
    });
    if (!this.ed) return;
    if (EditorLibre.sinWhatsapp) EditorLibre.sinWhatsapp();
    // las bolitas de color flotando a la derecha de la prenda (móvil), como en las camisetas
    if (this.colores.length > 1 && host.querySelector('.edl')) {
      var tira = document.createElement('div');
      tira.className = 'rop-libre-colores' + (this.colores.length <= 12 ? ' rop-libre-colores--1' : '');
      tira.innerHTML = this.colores.map(function (c) {
        return '<button type="button" class="rop-libre-colores__b" data-vc="' + c + '" title="' + c + '" aria-label="' + c +
          '" style="background:' + self.hex(c) + '"></button>';
      }).join('');
      tira.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-vc]');
        if (!b || !self.filas[0] || !self.filas[0][0]) return;
        self.filas[0][0].color = b.dataset.vc;
        self.pintarFilas(0); self.actualizar();
      });
      host.appendChild(tira); this._tiraColores = tira;
      host.classList.add('con-colores-der');
    }
    var ajustar = function () { if (self.ed && self.ed.redimensionar) self.ed.redimensionar(anchoHost()); };
    window.addEventListener('resize', ajustar);
    window.addEventListener('load', ajustar);
    [0, 300, 1000, 2500].forEach(function (ms) { setTimeout(ajustar, ms); });
    if (window.ResizeObserver) { try { new ResizeObserver(function () { ajustar(); }).observe(host); } catch (e) {} }
    // el editor sustituye a la subida de archivos
    var bl = $(this.root, '[data-bloque-logos]'); if (bl) bl.hidden = true;
    var av = $(this.root, '[data-aviso-colores]'); if (av) av.hidden = true;
    var tn = $(this.root, '[data-t-notas]'); if (tn) tn.textContent = '2 · Indicaciones (opcional)';
    this.pintarBolitas();
    this.actualizar();
    this.cargarEdicion();
  };

  Pack.prototype.pintarBolitas = function () {
    var self = this, caja = $(this.root, '[data-vista]'), cols = $(this.root, '[data-vista-colores]');
    if (!caja || !cols) return;
    caja.hidden = false;
    var actual = (this.filas[0] && this.filas[0][0] && this.filas[0][0].color) || this.colores[0];
    cols.innerHTML = this.colores.map(function (c) {
      return '<button type="button" class="pke-vista__dot' + (c === actual ? ' is-on' : '') + '" data-vc="' + c + '" title="' + c +
        '" aria-label="' + c + '" style="background:' + self.hex(c) + '"></button>';
    }).join('');
    if (!cols._enlazado) {
      cols._enlazado = true;
      cols.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('[data-vc]');
        if (!b || !self.filas[0] || !self.filas[0][0]) return;
        self.filas[0][0].color = b.dataset.vc;
        self.pintarFilas(0); self.actualizar();
      });
    }
    if (this._tiraColores) Array.prototype.forEach.call(this._tiraColores.querySelectorAll('[data-vc]'), function (b) { b.classList.toggle('is-sel', b.dataset.vc === actual); });
    $(this.root, '[data-vista-pie]').textContent = 'Pecho izquierdo ' + this.cfg.vista.cajas.pecho.cm.join(' × ') + ' cm · espalda ' +
      this.cfg.vista.cajas.espalda.cm.join(' × ') + ' cm (opcional, sin coste extra). Cambia de cara debajo de la prenda.';
  };

  // el color de la primera fila manda en la prenda que se ve
  Pack.prototype.sincronizarColor = function () {
    var c = (this.filas[0] && this.filas[0][0] && this.filas[0][0].color) || this.colores[0];
    if (c !== this._cEd) { this._cEd = c; this.ed.setColor(this.hex(c), c); this.pintarBolitas(); }
  };

  // ¿hay algo puesto en cada cara? Se anota como «archivo» (sin componerlo aún) para validar y mostrar el resumen
  Pack.prototype.sincronizarEditor = function () {
    var self = this;
    ['pecho', 'espalda'].forEach(function (k) {
      var oc = self.ed.ocupadoEn(self.zonasEd[k]);
      if (oc) {
        var a = self.archivos[k] || (self.archivos[k] = { desdeEditor: true, name: 'diseno-' + k + '.png', arreglos: [], transparente: true });
        a.nota = 'diseño del editor, ' + fmt(oc.w, 1) + ' × ' + fmt(oc.h, 1) + ' cm';
      } else if (self.archivos[k] && self.archivos[k].desdeEditor) delete self.archivos[k];
    });
    this.actualizar();
  };

  // al comprar: cada cara con diseño se compone a 300 ppp y viaja como su archivo
  Pack.prototype.prepararDiseno = async function () {
    if (!this.ed) return true;
    var self = this, ppcm = 118.11;
    for (var k in this.zonasEd) {
      var a = this.archivos[k];
      if (!a || !a.desdeEditor) continue;
      var z = this.zonasEd[k], area = z.cajas[0];
      var c = this.ed.componer(ppcm, { x: z.ventana[0], w: area[0] }, true);
      var rec = document.createElement('canvas');
      rec.width = c.width; rec.height = Math.round(area[1] * ppcm);
      rec.getContext('2d').drawImage(c, 0, 0);
      var nom = 'diseno-' + k + '-' + String(area[0]).replace('.', '_') + 'x' + String(area[1]).replace('.', '_') + 'cm.png';
      a.file = (window.ImgArreglo && ImgArreglo.pngConMedida)
        ? await ImgArreglo.pngConMedida(rec, area[0] * 10, nom)
        : await new Promise(function (ok) { rec.toBlob(function (b) { ok(new File([b], nom, { type: 'image/png' })); }, 'image/png'); });
      a.name = nom; a.px = [rec.width, rec.height];
    }
    return true;
  };

  /* pres === true: en vez de añadir al carrito, se manda a un presupuesto listo para pagar (pedido borrador del Worker).
     El bloqueo del doble clic va ANTES de componer el diseño, que es asíncrono. */
  Pack.prototype.alCarrito = function (pres) {
    var self = this;
    if (this.busy) return;
    pres = pres === true;
    var bP = pres ? $(this.root, '[data-presupuesto]') : null;
    if (pres) {
      if (!bP || !window.Presupuesto || !this.cfg.presupuestoUrl) return;
      this.busy = true; bP.disabled = true; bP.textContent = 'Preparando presupuesto…';
      $(this.root, '[data-add]').disabled = true;
    }
    this.prepararDiseno().then(function () { return pres ? null : self.guardarParaEditar(); }).then(function () { self.enviarCarrito(pres); }).catch(function () {
      if (pres) { self.busy = false; self.actualizar(); }
      self.flash('No se ha podido preparar el diseño. Vuelve a intentarlo.');
    });
  };

  /* Guarda el diseño del editor (y el reparto, el pack y las notas) para poder volver desde «Editar diseño» del carrito. Si algo falla,
     el pedido sigue adelante: solo se queda sin ese enlace. */
  Pack.prototype.guardarParaEditar = async function () {
    this._disenoId = null;
    if (!this.ed || !this.ed.estado || !window.indexedDB) return;
    try {
      if (this.ed.hayDiseno && !this.ed.hayDiseno()) return;
      var est = await conLimite(this.ed.estado(), 8000);
      var v = this.variante();
      est.pack = { variante: v ? v.id : null, filas: JSON.parse(JSON.stringify(this.filas)), notas: (($(this.root, '[data-notas]') || {}).value || '') };
      var id = 'k' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      await conLimite(Diseños.guardar(id, est), 6000);
      this._disenoId = id;
    } catch (e) { this._disenoId = null; }
  };

  // quita del carrito las líneas de un diseño anterior (las viejas, al corregirlo)
  Pack.prototype.quitarLineasDe = async function (id) {
    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var cart = await (await fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' } })).json();
    var updates = {};
    (cart.items || []).forEach(function (it) { if (it.properties && it.properties['_diseno'] === id) updates[it.key] = 0; });
    if (!Object.keys(updates).length) return;
    await fetch(raiz + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) });
  };

  // ?editar=<id> desde «Editar diseño» del carrito: recupera el diseño, el pack, el color, las tallas y las notas
  Pack.prototype.cargarEdicion = async function () {
    var id = new URLSearchParams(location.search).get('editar');
    if (!id || !this.ed) return;
    var self = this;
    try {
      var est = await Diseños.leer(id);
      if (!est) { this.flash('No encontramos ese diseño en este navegador. Puedes hacerlo de nuevo.'); return; }
      var pk = est.pack || {};
      delete est.pack; delete est.zonaCm;
      this.ed.cargarEstado(est);
      if (pk.variante) {
        var v = this.cfg.variantes.filter(function (x) { return String(x.id) === String(pk.variante); })[0];
        if (v) this.cambiarPack(v);
      }
      if (pk.filas && pk.filas.length === this.filas.length) {
        this.filas = pk.filas;
        this.grupos.forEach(function (g, i) { self.pintarFilas(i); });
      }
      var notas = $(this.root, '[data-notas]');
      if (notas && pk.notas) notas.value = pk.notas;
      this._editando = id;
      this.pintarBolitas();
      this.actualizar();
      this.flash('Tu diseño está cargado: cambia lo que quieras y vuelve a añadirlo al carrito.');
    } catch (e) {
      this.flash('No se ha podido recuperar el diseño.');
    }
  };

  Pack.prototype.enviarCarrito = function (pres) {
    var self = this, v = this.variante();
    if (!v || (this.busy && !pres)) { if (pres) { this.busy = false; this.actualizar(); } return; }
    var r = this.root, btn = $(r, '[data-add]');
    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    var campos = [['id', v.id], ['quantity', 1]];
    if (!pres && this._disenoId) { campos.push(['properties[_producto]', location.pathname]); campos.push(['properties[_diseno]', this._disenoId]); }
    var resumen = [], datos = [];
    this.grupos.forEach(function (g, i) {
      self.filas[i].forEach(function (fila) {
        var trozo = [], tallas = {};
        self.cfg.tallas.forEach(function (s) {
          var n = fila.tallas[s] || 0;
          if (n > 0) { trozo.push(n + ' × ' + s); tallas[s] = n; }
        });
        if (!trozo.length) return;
        var etiqueta = (g.nombre ? g.nombre + ' ' : '') + fila.color;
        campos.push(['properties[' + etiqueta + ']', trozo.join(', ')]);
        resumen.push(etiqueta + ': ' + trozo.join(', '));
        datos.push({ grupo: g.nombre || null, color: fila.color, tallas: tallas });
      });
    });
    campos.push(['properties[Reparto]', resumen.join(' · ')]);
    campos.push(['properties[_reparto_json]', JSON.stringify(datos)]);
    var notas = $(r, '[data-notas]').value.trim();
    if (notas) campos.push(['properties[Notas]', notas]);
    var res = [], arr = [];
    Object.keys(this.archivos).forEach(function (k) {
      res.push(self.cfg.etiquetas[k] + ': ' + self.archivos[k].nota);
      (self.archivos[k].arreglos || []).forEach(function (x) {
        arr.push(self.cfg.etiquetas[k] + ': ' + (x === 'fondo' ? 'fondo quitado en la web' : 'bordes afinados en la web'));
      });
    });
    if (res.length) campos.push(['properties[_resolucion]', res.join(' · ')]);
    if (arr.length) campos.push(['properties[_arreglos]', arr.join(' · ')]);

    if (pres) { this.enviarPresupuesto(campos, v); return; }

    this.busy = true;
    var nArch = Object.keys(this.archivos).length;
    var textoSubida = nArch > 1 ? 'Subiendo los archivos' : (nArch ? 'Subiendo el logo' : 'Enviando el pedido');
    if (window.Cargando) Cargando.ocupar(btn, textoSubida + '…', nArch > 0);
    else { btn.disabled = true; btn.textContent = textoSubida + '…'; }
    var fd = new FormData();
    campos.forEach(function (f) { fd.append(f[0], f[1]); });
    Object.keys(this.archivos).forEach(function (k) {
      var a = self.archivos[k];
      fd.append('properties[' + self.cfg.etiquetas[k] + ']', a.file, a.name);
    });
    var extras = this.extras();
    var envio = window.Cargando
      ? Cargando.subir(raiz + 'cart/add.js', fd, function (p) {
          if (p >= 100) Cargando.ocupar(btn, 'Guardando…');
          else Cargando.pct(btn, p, textoSubida);
        })
      : fetch(raiz + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
    envio
      .then(function (res) {
        if (!res.ok) throw new Error('carrito');
        if (window.Cargando) Cargando.ocupar(btn, 'Vamos al carrito…');
        if (!extras.length) return null;
        // los suplementos por talla grande van como líneas aparte, a la vista del cliente
        return fetch(raiz + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: extras.map(function (e) { return { id: e.id, quantity: e.uds }; }) })
        });
      })
      .then(function () { return self._editando ? self.quitarLineasDe(self._editando).catch(function () { /* se quedan y el cliente las quita a mano */ }) : null; })
      .then(function () { window.onbeforeunload = null; window.location.href = raiz + 'cart'; })
      .catch(function () {
        self.busy = false;
        self.flash('No se ha podido añadir al carrito. Inténtalo otra vez o escríbenos por WhatsApp.');
        self.actualizar();
      });
  };

  /* Misma lista de campos que el carrito (variante, reparto, notas, logos, suplementos), pero a Presupuesto.crear. */
  Pack.prototype.enviarPresupuesto = function (campos, v) {
    var self = this, r = this.root, bP = $(r, '[data-presupuesto]'), nota = $(r, '[data-presupuesto-nota]');
    var fail = function (e) {
      self.busy = false; self.actualizar();
      self.flash((e && e.message) || 'No se ha podido preparar el presupuesto. Inténtalo otra vez o escríbenos por WhatsApp.');
    };
    var esBlob = function (x) { return typeof Blob !== 'undefined' && x instanceof Blob; };
    // montaje del diseño sobre la prenda (solo con editor); si falla, el presupuesto sale igual
    var mockup = new Promise(function (ok) {
      try {
        var c = self.ed && self.ed.mockup ? self.ed.mockup(900) : null;
        if (c && c.toBlob) c.toBlob(function (b) { ok(b || null); }, 'image/jpeg', 0.86); else ok(null);
      } catch (e) { ok(null); }
    });
    mockup.then(function (mk) {
      var fd = new FormData();
      campos.forEach(function (f) { fd.append(f[0], f[1]); });
      if (esBlob(mk)) fd.append('properties[_Mockup]', mk, 'mockup.jpg');
      Object.keys(self.archivos).forEach(function (k) {
        var a = self.archivos[k];
        if (esBlob(a.file)) fd.append('properties[' + self.cfg.etiquetas[k] + ']', a.file, a.name);
      });
      var extra = self.extras().map(function (e) { return { id: e.id, quantity: e.uds }; });
      var datos = Presupuesto.desdeForm(fd, extra);
      var titulo = (document.querySelector('h1') || document).textContent.replace(/\s+/g, ' ').trim();
      return Presupuesto.crear(self.cfg.presupuestoUrl, { titulo: titulo.slice(0, 120), nota: '', lineas: datos.lineas, ficheros: datos.ficheros })
        .then(function (pres) {
          var total = pres.total ? money(Math.round(parseFloat(pres.total) * 100)) : '';
          pres.totalTexto = total ? total + ' IVA incl.' : '';
          var texto = 'Presupuesto de Imprimirlo · ' + titulo + '\n' + (total ? 'Precio: ' + total + ' IVA incl.\n' : '') +
            (pres.landing ? 'Mira el montaje y págalo aquí: ' + pres.landing : 'Págalo aquí: ' + pres.url);
          var copiado = false;
          var fin = function () {
            Presupuesto.mostrar(nota, pres, texto, copiado);
            // aviso claro: el botón solo cambiaba de nombre y parecía que no había pasado nada (Xavi, 24/10: «no me funciona»)
            if (nota) {
              nota.hidden = false;
              nota.textContent = copiado
                ? '✓ Presupuesto ' + (pres.nombre || '') + ' creado y enlace copiado: pégalo en WhatsApp o en un correo. «Enviar presupuesto» lo vuelve a mandar.'
                : '✓ Presupuesto ' + (pres.nombre || '') + ' creado. Pulsa «Enviar presupuesto» para mandarlo por WhatsApp o copiar el enlace.';
            }
            self.busy = false; self.actualizar();
          };
          if (!Presupuesto.esMovil() && navigator.clipboard) navigator.clipboard.writeText(texto).then(function () { copiado = true; fin(); }, fin); else fin();
        });
    }).catch(fail);
  };

  function init() {
    document.querySelectorAll('[data-pack-empresa]').forEach(function (el) { if (!el._pke) el._pke = new Pack(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();